// FIXME: This should be exported from the ra-core package
type CanAccessParams<
  RecordType extends Record<string, any> = Record<string, any>,
> = {
  action: string;
  resource: string;
  record?: RecordType;
};

// Resources only admins can access
const ADMIN_ONLY_RESOURCES = ["sales", "database", "integrations", "settings"];

export const canAccess = <
  RecordType extends Record<string, any> = Record<string, any>,
>(
  role: string,
  params: CanAccessParams<RecordType>,
) => {
  if (role === "admin") {
    return true;
  }

  if (ADMIN_ONLY_RESOURCES.includes(params.resource)) {
    return false;
  }

  return true;
};